import { render, staticRenderFns } from "./CourseraSearch.vue?vue&type=template&id=1150c168&scoped=true&"
import script from "./CourseraSearch.vue?vue&type=script&lang=ts&"
export * from "./CourseraSearch.vue?vue&type=script&lang=ts&"
import style0 from "./CourseraSearch.vue?vue&type=style&index=0&id=1150c168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1150c168",
  null
  
)

export default component.exports